<template>
  <div
    class="info-tooltip-container"
    ref="tooltip"
    @mouseenter="visible = true"
    @mouseleave="visible = false"
  >
    <span class="info-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/circle-info-solid-dark-grey.svg')"
        alt="Icon"
      />
    </span>
    <div
      v-if="visible"
      class="info-popup"
      :class="{ 'info-popup-with-images': validImages.length }"
    >
      <div v-if="validImages.length" class="info-popup-images">
        <img
          class="info-popup-image"
          :src="currentImageSrc"
          :alt="`Hinweisbild ${currentImageIndex + 1}`"
        />
        <div v-if="validImages.length > 1" class="info-popup-image-navigation">
          <button
            type="button"
            class="info-popup-image-button"
            aria-label="Vorheriges Hinweisbild"
            @click.stop="prevImage"
          >
            ‹ Vorheriges Bild
          </button>
          <button
            type="button"
            class="info-popup-image-button"
            aria-label="Nächstes Hinweisbild"
            @click.stop="nextImage"
          >
            Nächstes Bild ›
          </button>
        </div>
      </div>
      <div class="info-popup-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      currentImageIndex: 0
    };
  },
  computed: {
    validImages() {
      return this.images.filter(image => typeof image === 'string' && image.trim() !== '');
    },
    currentImageSrc() {
      return this.validImages[this.currentImageIndex] || '';
    }
  },
  watch: {
    validImages() {
      this.currentImageIndex = 0;
    }
  },
  methods: {
    togglePopup() {
      this.visible = !this.visible;
    },
    prevImage() {
      if (this.validImages.length > 1) {
        this.currentImageIndex =
          (this.currentImageIndex - 1 + this.validImages.length) % this.validImages.length;
      }
    },
    nextImage() {
      if (this.validImages.length > 1) {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.validImages.length;
      }
    },
    handleClickOutside(event) {
      if (this.visible && !this.$refs.tooltip.contains(event.target)) {
        this.visible = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped src="@/styles/InfoTooltip.css">

</style>
